// @flow

import React, { type Node } from 'react';
import { useIsMobile } from '@tectonics/hooks';

type PaymentInfoProps = {
  label: string,
  children: Node,
  first?: bool,
}

export function PaymentInfo({ label, children, first }: PaymentInfoProps): Node {
  const isMobile = useIsMobile();
  return (
    <div style={(first && !isMobile) ? PaymentInfoItemFirstWrapperStyle : PaymentInfoItemWrapperStyle}>
      <dl style={PaymentInfoItemStyle}>
        <dt style={PaymentInfoItemLabelStyle}>{label}</dt>
        <dd style={PaymentInfoItemValueStyle}>{children}</dd>
      </dl>
    </div>
  );
}

const PaymentInfoItemWrapperStyle = {
  width: '50%',
  textAlign: 'center',
};

const PaymentInfoItemFirstWrapperStyle = {
  width: '49%',
  textAlign: 'center',
  borderRight: '1px solid #cbcbcb',
};

const PaymentInfoItemStyle = {
  fontWeight: '400',
  display: 'inline-block',
  flexDirection: 'column',
  width: 'auto',
  justifycontent: 'space-around',
  flexGrow: '1',
  textAlign: 'left',
  color: '#738093',
};

const PaymentInfoItemLabelStyle = {
  fontSize: '16px',
  margin: '0',
  color: '#a3a3a3',
};

const PaymentInfoItemValueStyle = {
  fontSize: '22px',
  margin: '0',
};
